var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPreviewMoney = function SvgPreviewMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.39209 7.76592V6.36592H1.62409V5.44192H0.39209V4.04192H1.62409V0.919922H3.82209L5.60009 4.04192H7.84009V0.919922H9.80009V4.04192H10.9201V5.44192H9.80009V6.36592H10.9201V7.76592H9.80009V10.9999H7.70009L5.83809 7.76592H3.58409V10.9999H1.62409V7.76592H0.39209ZM3.58409 6.36592H5.02609L4.49409 5.44192H3.58409V6.36592ZM6.93009 6.36592H7.84009V5.44192H6.41209L6.93009 6.36592ZM3.58409 4.04192H3.69609L3.58409 3.84592V4.04192ZM7.84009 7.96192V7.76592H7.72809L7.84009 7.96192Z",
    fill: "#748CAD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreviewMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/previewMoney.f8538d87.svg";
export { ForwardRef as ReactComponent };